var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74969 2.88414C3.50484 2.88414 2.50719 3.88179 2.50719 5.12664V40.0016C2.50719 41.2465 3.50484 42.2441 4.74969 42.2441H45.2497C46.4945 42.2441 47.4922 41.2465 47.4922 40.0016V10.7516C47.4922 9.50679 46.4945 8.50914 45.2497 8.50914H21.4278C20.5349 8.50914 19.6709 8.14941 19.038 7.5165L14.7348 3.21338C14.524 3.00253 14.2349 2.88414 13.9466 2.88414H4.74969ZM0.242188 5.12664C0.242188 2.63087 2.25391 0.619141 4.74969 0.619141H13.9466C14.8395 0.619141 15.7035 0.978874 16.3364 1.61178L20.6395 5.9149C20.8504 6.12575 21.1395 6.24414 21.4278 6.24414H45.2497C47.7455 6.24414 49.7572 8.25587 49.7572 10.7516V40.0016C49.7572 42.4974 47.7455 44.5091 45.2497 44.5091H4.74969C2.25391 44.5091 0.242188 42.4974 0.242188 40.0016V5.12664Z",
    fill: "#002852"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderBlue);
export default __webpack_public_path__ + "static/media/folder_blue.d6414c2b.svg";
export { ForwardRef as ReactComponent };